<template lang='pug'>
section
  s-page-title(
    :previous='true'
    :title='departmentId ? "Редактирование отдела" : "Добавление отдела"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs8)
          v-text-field(
            :error='errors.has("department_name")'
            :error-messages='errors.first("department_name")'
            v-model='item.department_name'
            label='Название'
          )
        v-flex(xs4)
          v-checkbox(
            v-model='item.published'
            label='Публиковать на сайте'
            color='primary'
          )                    
        v-flex(xs12 sm6 md4)
          s-phone-input(
            :error='errors.has("phone")'
            :error-messages='errors.first("phone")'
            v-model='item.phone'
            label='Телефон'
          )
        v-flex(xs12 sm6 md4)
          v-text-field(
            :error='errors.has("email")'
            :error-messages='errors.first("email")'
            v-model='item.email'
            label='Email'
          )
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Дополнительная информация
          ckeditor(v-model='item.description')          
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        :loading='isLoading'
        @click.native='onSave'
        color='primary'
        depressed
      ) Сохранить
  managers(
    v-if='departmentId'
    :department-id='departmentId'
    class='mt-5'
  )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Managers from './Managers'
import Ckeditor from '@/components/async/Ckeditor'

export default {
  props: [
    'id', 
    'departmentId'
    ],
  components: {
    Ckeditor,
    Managers
  },

  data: () => ({
    item: {},
    editor: true,
    focused: false
  }),

  async created() {
    if (this.departmentId) {
      this.item = (await this.fetchSingle({
        id: this.departmentId
      })).data
    }
  },

  methods: {
    async onSave() {
      let { departmentId, item } = this

      try {
        if (departmentId) {
          await this.update({
            id: departmentId,
            data: item
          })
        } else {
          await this.create({
            data: Object.assign({}, item, {
              office_id: this.id
            })
          })
        }

        this.$root.showSnack(`Отдел сохранен`)

        let { id } = this.$route.params
        this.$router.push({
          name: 'Admin.Offices.Edit',
          params: {
            id
          }
        })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('admin/offices/departments', [
      'fetchSingle',
      'update',
      'create'
    ])
  },

  computed: {
    ...mapGetters('admin/offices/departments', ['isLoading'])
  }
}
</script>
